import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FastBridgeLinkGeneratorService {

  public getStudentAtAGlanceReportDeepLink(studentRenaissanceId: string | undefined) {
    return `SAAG_REPORT?rid=${studentRenaissanceId}`;
  }

  public getProgressMonitoringReportDeepLink(studentRenaissanceId: string | null, assessmentName: string | null) {
    return `PM_REPORT?rid=${studentRenaissanceId}&asmt=${assessmentName}`;
  }
}
